import { useTheme } from 'styled-components';
import Tags from '../Tags';
import DataPendingTag from '../DataPendingTag/DataPendingTag';
import useGetFleetId from '../../../API/hooks/useGetFleetId';
import useDeviceOnlineStatus from '../../../API/hooks/devices/useDeviceOnlineStatus';
import { ThemeType } from '../../../theme/themeType';
import { getTripDuration } from '../../../utils/dateUtils';
import { convertMsToKm, generateDistance } from '../../../utils/unitsUtils';
import { FeaturesManagement } from '../../../featuresControl';

type Props = {
  startAt?: string;
  deviceId?: string | null;
  speedMs?: number;
  distanceInKm?: number;
  onClick?: () => void;
};

function ActiveTripTags({
  startAt, deviceId, speedMs, distanceInKm, onClick,
}: Props): JSX.Element {
  const theme = useTheme() as ThemeType;
  const fleetId = useGetFleetId();
  const { data } = useDeviceOnlineStatus(
    fleetId,
    deviceId ?? null,
    true,
    FeaturesManagement.productivity.refetchInterval,
  );
  const isOnline = data?.isOnline ?? false;

  const distanceLabel = `current distance ${generateDistance(distanceInKm)}`;
  const speedLabel = speedMs !== null && speedMs !== undefined
    ? `speed is ${convertMsToKm(speedMs)} km/h, `
    : '';

  return (
    <>
      <Tags.Status
        onClick={onClick}
        backgroundColor={theme.colors.main_cta}
        label={isOnline
          ? `Ongoing trip: ${getTripDuration(startAt, null)}, ${speedLabel}${distanceLabel}`
          : 'Ongoing trip'}
      />
      {!isOnline && <DataPendingTag startAt={startAt} />}
    </>
  );
}

export default ActiveTripTags;
